/*
 * Copyright (c) 2024. . Yantodev - All Rights Reserved.
 * @Author  :  yantodev
 * mailto : ekocahyanto007@gmail.com
 * link : https://yantodev.my.id/
 */

export const REQUEST_BILLINGS = 'REQUEST_BILLINGS';
export const REQUEST_BILLINGS_SUCCESS = 'REQUEST_BILLINGS_SUCCESS';
export const REQUEST_BILLINGS_FAILURE = 'REQUEST_BILLINGS_FAILURE';

export const REQUEST_BILLING = 'REQUEST_BILLING';
export const REQUEST_BILLING_SUCCESS = 'REQUEST_BILLING_SUCCESS';
export const REQUEST_BILLING_FAILURE = 'REQUEST_BILLING_FAILURE';

export const REQUEST_ADD_BILLING = 'REQUEST_ADD_BILLING';
export const REQUEST_ADD_BILLING_SUCCESS = 'REQUEST_ADD_BILLING_SUCCESS';
export const REQUEST_ADD_BILLING_FAILURE = 'REQUEST_ADD_BILLING_FAILURE';

export const REQUEST_UPDATE_BILLING = 'REQUEST_UPDATE_BILLING';
export const REQUEST_UPDATE_BILLING_SUCCESS = 'REQUEST_UPDATE_BILLING_SUCCESS';
export const REQUEST_UPDATE_BILLING_FAILURE = 'REQUEST_UPDATE_BILLING_FAILURE';

export const REQUEST_DELETE_BILLING = 'REQUEST_DELETE_BILLING';
export const REQUEST_DELETE_BILLING_SUCCESS = 'REQUEST_DELETE_BILLING_SUCCESS';
export const REQUEST_DELETE_BILLING_FAILURE = 'REQUEST_DELETE_BILLING_FAILURE';

export const REQUEST_POSTING_BILLING = 'REQUEST_POSTING_BILLING';
export const REQUEST_POSTING_BILLING_SUCCESS = 'REQUEST_POSTING_BILLING_SUCCESS';
export const REQUEST_POSTING_BILLING_FAILURE = 'REQUEST_POSTING_BILLING_FAILURE';

export const REQUEST_AUTONUMBER_BILLING = 'REQUEST_AUTONUMBER_BILLING';
export const REQUEST_AUTONUMBER_BILLING_SUCCESS = 'REQUEST_AUTONUMBER_BILLING_SUCCESS';
export const REQUEST_AUTONUMBER_BILLING_FAILURE = 'REQUEST_AUTONUMBER_BILLING_FAILURE';


export const REQUEST_BILLINGS_POSTED = 'REQUEST_BILLINGS_POSTED';
export const REQUEST_BILLINGS_POSTED_SUCCESS = 'REQUEST_BILLINGS_POSTED_SUCCESS';
export const REQUEST_BILLINGS_POSTED_FAILURE = 'REQUEST_BILLINGS_POSTED_FAILURE';

export const REQUEST_PAID_BILLING = 'REQUEST_PAID_BILLING';
export const REQUEST_PAID_BILLING_SUCCESS = 'REQUEST_PAID_BILLING_SUCCESS';
export const REQUEST_PAID_BILLING_FAILURE = 'REQUEST_PAID_BILLING_FAILURE';

export const REQUEST_BILLINGS_PAIDED = 'REQUEST_BILLINGS_PAIDED';
export const REQUEST_BILLINGS_PAIDED_SUCCESS = 'REQUEST_BILLINGS_PAIDED_SUCCESS';
export const REQUEST_BILLINGS_PAIDED_FAILURE = 'REQUEST_BILLINGS_PAIDED_FAILURE';

export const REQUEST_PRINT_INVOICE = 'REQUEST_PRINT_INVOICE';
export const REQUEST_PRINT_INVOICE_FAILURE = 'REQUEST_PRINT_INVOICE_FAILURE';
export const REQUEST_PRINT_INVOICE_SUCCESS = 'REQUEST_PRINT_INVOICE_SUCCESS';

export const REQUEST_BILLINGS_PRINT = 'REQUEST_BILLINGS_PRINT';
export const REQUEST_BILLINGS_PRINT_FAILURE = 'REQUEST_BILLINGS_PRINT_FAILURE';
export const REQUEST_BILLINGS_PRINT_SUCCESS = 'REQUEST_BILLINGS_PRINT_SUCCESS';

export const REQUEST_FILE_DOWNLOAD = 'REQUEST_FILE_DOWNLOAD';
export const REQUEST_FILE_DOWNLOAD_SUCCESS = 'REQUEST_FILE_DOWNLOAD_SUCCESS';
export const REQUEST_FILE_DOWNLOAD_FAILURE = 'REQUEST_FILE_DOWNLOAD_FAILURE';

export const REQUEST_SEND_WHATSAPP = 'REQUEST_SEND_WHATSAPP';
export const REQUEST_SEND_WHATSAPP_SUCCESS = 'REQUEST_SEND_WHATSAPP_SUCCESS';
export const REQUEST_SEND_WHATSAPP_FAILURE = 'REQUEST_SEND_WHATSAPP_FAILURE';

export const REQUEST_BILLINGS_RECEIVED_MANAGER = 'REQUEST_BILLINGS_RECEIVED_MANAGER';
export const REQUEST_BILLINGS_RECEIVED_MANAGER_SUCCESS = 'REQUEST_BILLINGS_RECEIVED_MANAGER_SUCCESS';
export const REQUEST_BILLINGS_RECEIVED_MANAGER_FAILURE = 'REQUEST_BILLINGS_RECEIVED_MANAGER_FAILURE';

export const REQUEST_DISCOUNT_BILLING = 'REQUEST_DISCOUNT_BILLING';
export const REQUEST_DISCOUNT_BILLING_SUCCESS = 'REQUEST_DISCOUNT_BILLING_SUCCESS';
export const REQUEST_DISCOUNT_BILLING_FAILURE = 'REQUEST_DISCOUNT_BILLING_FAILURE';